'use strict';

import { debounce, throttle } from 'throttle-debounce';

window.messageIsSending = false;

$(function(){
    var bdy = $('body');
    var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9+/=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}};
    window.lastActivity = Date.now();

    String.prototype.replaceAt = function (index, char) {
        let arr = this.split('');
        arr[index] = char;
        return arr.join('');
    };

    String.prototype.escape = function () {
        let p = /(?:<[a-zA-Z]+>)|(?:<\/[a-zA-Z]+>)|(?<lt><)|(?<gt>>)/g,
            result = this,
            match = p.exec(result);

        while (match !== null) {
            if (match.groups.lt !== undefined) {
                result = result.replaceAt(match.index, '&lt;');
            }
            else if (match.groups.gt !== undefined) {
                result = result.replaceAt(match.index, '&gt;');
            }
            match = p.exec(result);
        }
        return result;
    };

    $.templates('chatListTmpl', { markup: '#chat-list-wrap-tmpl' });
    $.templates('chatWrapTmpl', { markup: '#chat-wrap-tmpl' });
    $.templates('chatItemTmpl', { markup: '#chat-item-tmpl' });
    $.templates('listMessagesTmpl', { markup: '#list-messages-tmpl' });
    $.templates('messageItemTmpl', { markup: '#message-item-tmpl' });
    $.templates('attachmentItemTmpl', { markup: '#attachment-item-tmpl' });
    $.templates('groupItemTmpl', { markup: '#group-item-tmpl' });
    $.templates('profileViewTmpl', { markup: '#profile-view-tmpl' });
    $.templates('searchBlockTmpl', { markup: '#search-block-tmpl' });
    $.templates('searchItemChatsTmpl', { markup: '#search-item-chats-tmpl' });
    $.templates('searchItemMessagesTmpl', { markup: '#search-item-messages-tmpl' });
    $.templates('dialogSearchItemMessagesTmpl', { markup: '#dialog-search-item-messages-tmpl' });

    bdy.on('mousemove keyup click', function () {
        window.lastActivity = Date.now();
    });
    bdy.on('click', function (e) {
        if ($(e.target).hasClass('chatGroup-link'))
            return false;
        var chatContainer = $(this).find('#chat-content .chat-container');
        var chatId = chatContainer.closest('.chat-result-content').data('id');
        if (chatContainer.length)
            setViewed(chatId, chatContainer)
    });


    bdy.on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    bdy.on('click', '.add-link', function (e) {
        e.preventDefault();
        var $modal = $('#add-edit-modal');
        $modal.modal('show');
    });

    bdy.on('dragenter', function(e) {
        if ($(e.target).attr('id') === "chat-content" || $(e.target).closest('#chat-content').length > 0) {
            bdy.find('.file-input.theme-fas').show();
        }
    });

    bdy.on('dragover', function(e) {
        e.preventDefault();
    });

    bdy.on('dragend', function(e) {
        bdy.find('.file-input.theme-fas').hide();
    });

    bdy.on('click', 'button.send-attachments', function(e){
        e.preventDefault();
        bdy.find('.file-input.theme-fas').toggle();
    });

    window.isMouseOverChats = false;

    bdy.on('click', '#chatgroup-container .chatGroup-link', function(e) {
        e.preventDefault();

        let btn = $(this),
            chatsContainerEl = document.querySelector('#chats-container'),
            chatGroupName = btn.find('.chat-group-name').text();
        
        chatGroupName = chatGroupName.length > 0 ? chatGroupName : "Мои";

        bdy.find('#chatgroup-container .chatGroup-link').removeClass('active');
        btn.addClass('active');


        // Get chats
        $.ajax({
            type: 'GET',
            url: '/chats-by-group/'+btn.data('id'),
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    // Render block
                    $(chatsContainerEl).html(
                        $.render.chatListTmpl({
                            folderName: chatGroupName,
                            chats: res.chats,
                            userId: window.userId
                        })
                    );

                    // Update readAll button checkbox
                    let unreadCount = parseInt(btn[0].querySelector('span.unread').innerText);
                    
                    if (unreadCount === 0) {
                        document.querySelector('#readAllInGroup').checked = true;
                        document.querySelector('.read-all-button').classList.add('disabled');
                    }

                    let chatsBlockEl = document.querySelector('.chats-block');

                    chatsBlockEl.addEventListener('mouseleave',
                        event => {
                            event.stopPropagation();
                            if (event.target !== chatsBlockEl) {
                                return;
                            }
                            isMouseOverChats = false;
                        },
                        { capture: false }
                    );
                    chatsBlockEl.addEventListener('mouseenter',
                        event => {
                            event.stopPropagation();
                            if (event.target !== chatsBlockEl) {
                                return;
                            }
                            isMouseOverChats = true;
                        },
                        { capture: false }
                    );
                    
                    chatsContainerEl.dispatchEvent(new Event('groupLoad'));
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка получения списка чатов', { type: 'danger' });
                }
            },
            beforeSend: function() {
                if (bdy.find('.search-results-list').length === 0) {
                    bdy.find('#chat-content').html('');
                }
            },
            dataType: 'json'
        });
    });

    bdy.on('click', '#chats-container .chat-link', function(e) {
        e.preventDefault();

        if (loadingMessages) {
            $.growl('Сообщения уже загружаются, подождите...');
            return;
        }
        
        let btn = $(this),
            chatGroupName = btn.data('name'),
            chatName = chatGroupName.length > 0 ? chatGroupName : "John Doe (@notfound)",
            $mainChatWindowId = bdy.find('.chat-result-content').data('id'),
            activeChatLink = document.querySelector('#chats-container .chat-link.active');
        
        if (activeChatLink) {
            activeChatLink.classList.remove('active');
        }
        btn[0].classList.add('active');
        
        // If wanted chat is opened jump to the clicked message
        if (btn.data('chatid') === $mainChatWindowId) {
            console.log('1')
            jumpToMessage(btn);
            return;
        }

        // Get chat
        $.ajax({
            type: 'GET',
            url: '/chat/'+btn.data('chatid'),
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    // Set last message id
                    window.lastMessId = res.messages.length
                        ? res.messages[res.messages.length - 1].id
                        : '0';

                    // Render block
                    // Escape html <> characters
                    res.messages.forEach(msg => {
                        msg.text = msg.text.escape();
                    });

                    let { assigned } = res.chat,
                        userId = document.querySelector('#chat-app-wrap').dataset.userId;

                    bdy.find('#chat-content').html(
                        $.render.chatWrapTmpl({
                            userId,
                            chatName: chatName,
                            chat: {
                                ...res.chat,
                                isOccupied: (assigned !== null && assigned != userId) 
                            },
                            messages: res.messages
                        })
                    );
                    let chatMsgInputEl = document.querySelector('.chat-result-content .chat-message-input');

                    if (chatMsgInputEl.getAttribute('disabled') !== null) {
                        messageInputsBlocked = true;
                    }
                    
                    showMeta(bdy.find('#chat-content .chat-container .message'));

                    let chatContainer = bdy.find('#chat-content .chat-container');

                    chatContainer.data('chat', res.chat);

                    if (!!chatContainer[0]) {
                        chatContainer[0].scrollTop = chatContainer[0].scrollHeight;
                    }
                    
                    setTimeout(function(){
                        setViewed(res.chat.chat_id, chatContainer);

                        bdy.find('#chat-content #message-send-form .fileInput').fileinput({
                            language: "ru",
                            theme: "fas",
                            uploadUrl: "/chat/upload",
                            allowedFileExtensions: ["jpg", "jpeg", "gif", "bmp", "png", "txt", "rtf", "doc", "docx", "xls", "xlsx", "pdf", "zip", "rar", "7z", "mp4"],
                            allowedPreviewTypes: ['image'],
                            uploadAsync: false,
                            maxFileSize: 200000,
                            showRemove: false,
                            showCancel: false,
                            showBrowse: false,
                            showUpload: false,
                            showCaption: false,
                            browseOnZoneClick: true,
                            showUploadedThumbs: false,
                            showAjaxErrorDetails: false,
                            elErrorContainer: false,
                            autoReplace: true,
                            fileActionSettings: {
                                showUpload: false,
                                showZoom: false,
                                showDrag: false,
                                showRemove: false
                            },
                            previewSettings: {
                                pdf: {width: "120px", height: "90px"},
                                other: {width: "120px", height: "90px"}
                            },
                            uploadExtraData: function(previewId) {
                                var obj = {};

                                obj.allowedFileExtensions = this.allowedFileExtensions;
                                // Собрать данные о чате
                                var $block = this.$parent.closest('.chat-result-content');
                                obj.caption = $block.find('#message-send-form .chat-message-input').val();
                                obj.chatId = $block.data('id');
                                if(bdy.find('.answer-link-form').length)
                                    obj.replyto = bdy.find('.answer-link-form').data('rid');

                                return obj;
                            },
                            msgUploadThreshold: "Обработка",
                            msgUploadEnd: "Обработка завершена",
                            layoutTemplates: {

                            }
                        }).on('filecleared fileclear filereset', function(event) {
                            bdy.find('.file-input.theme-fas').hide();
                        }).on('filepreajax', function(event, previewId) {
                            $(this).closest('form').find('textarea button').each(function(idx, el){
                                $(el).attr('disabled', 'disabled')
                            });
                        }).on('fileuploaderror filebatchuploaderror', function(event, data, msg) {
                            var res = data.response;
                            console.log('File upload error', msg, data);

                            if (typeof res.error !== 'undefined')
                                for (var x in res.error)
                                    $.growl(res.error[x], {type: 'danger'});
                            else
                                $.growl(msg, { type: 'danger' });
                        });
                    }, 1000);

                    // Handle audio and voices
                    chatContainer.find('audio').each(function(idx, el) {
                        var duration = parseInt($(el).data('duration'));
                        if (isNaN(duration))
                            duration = -1;
                        $(el).mediaelementplayer({
                            features: ['playpause', 'progress', 'current'],
                            duration: duration,
                            success: function (media, node) {
                                $(node).addClass('style-converted');
                            }
                        });
                    });
                    
                    chatContainer.closest('#chat-content').find('.chat-message-input').focus();

                    // Auto height for textarea
                    document.querySelector('textarea.chat-message-input').addEventListener('input', function (e) {
                        e.target.style.height = "5px";
                        e.target.style.height = (e.target.scrollHeight)+"px";
                    });

                    console.log('2')
                    setChatLoadingState(false);
                    jumpToMessage(btn);
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка получения чата', { type: 'danger' });
                    
                    setChatLoadingState(false);

                    if (activeChatLink) {
                        activeChatLink.classList.add('active');
                    }
                    btn[0].classList.remove('active');
                }
            },
            dataType: 'json'
        });

        setChatLoadingState();

        // Open the chat group if it's not a message link
        if (btn.hasClass('from-search') && !btn.hasClass('message-link')) {
            document
                .querySelector('#chats-container')
                .addEventListener('groupLoad',
                    () => {
                        document
                            .querySelector(`#chats-container .chat-link[data-chatid="${btn.data('chatid')}"]`)
                            .classList
                            .add('active');
                    },
                    { once: true }
                );
            bdy.find('.chatGroup-link[data-id="' + btn.data('groupid') + '"]').trigger('click');
        }
    });

    window.loadingMessages = false;

    window.jumpToMessage = function ($messageLink) {
        if ($messageLink.hasClass('from-search') && $messageLink.hasClass('message-link')) {
            let $container = bdy.find('.chat-result-content .chat-container'),
                goTo = $messageLink.data('messageid'),
                $goToMessage = $container.find(`.message[data-mid="${goTo}"]`);

            if (!$goToMessage.length) {
                if (loadingMessages) {
                    return;
                }

                loadMoreMessages($messageLink.data('id'), () => {
                    scrollToMessage(
                        $container.find(`.message[data-mid="${goTo}"]`)
                    );
                });

                return console.log('more messages loaded');
            }

            scrollToMessage($goToMessage);
        }
    }

    function scrollToMessage ($goToMessage) {
        let $container = bdy.find('.chat-result-content .chat-container');

        $container.animate(
            {
                scrollTop: '+=' + ($goToMessage.closest('.row').position().top - 150)
            }, 
            200,
            'linear',
            () => {
                $container.find('.message.reply-highlight').removeClass('reply-highlight');
                $goToMessage.addClass('reply-highlight');
            }
        );
    }

    function loadMoreMessages (toMessageId, callback = null) {
        let $btn = $(document.querySelector('.load-more-messages')),
            chatContainer = $btn.closest('#chat-content').find('.chat-container'),
            chatId = $btn.closest('.chat-result-content').data('id'),
            $firstMessage = chatContainer.find('.message').eq(0),
            firstMessageId = $firstMessage.data('id');

        $.ajax({
            type: 'GET',
            url: `/chat/${chatId}/messages/${firstMessageId}/${toMessageId}`,
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    console.log('message updated');
                    if (!!res.messages) {
                        if (
                            res.messages.length > 1000 &&
                            !confirm(`Загружено ${res.messages.length} сообщений, это может повлиять на производительность, продолжить?`)
                        ) {
                            setChatLoadingState(false);
                            return;
                        }
                        // Escape html <> characters
                        res.messages.forEach(msg => {
                            msg.text = msg.text.escape();
                        });

                        $btn.after($.render.listMessagesTmpl(res));
                        showMeta(bdy.find('#chat-content .chat-container .message'));
                    }
                    // Handle audio and voices
                    chatContainer.find('audio').each(function(idx, el) {
                        var duration = parseInt($(el).data('duration'));
                        if (isNaN(duration))
                            duration = -1;
                        $(el).mediaelementplayer({
                            features: ['playpause', 'progress', 'current'],
                            duration: duration,
                            success: function (media, node) {
                                $(node).addClass('style-converted');
                            }
                        });
                    });
                    
                    setChatLoadingState(false);

                    if (callback !== null) {
                        callback();
                    }
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка дозагрузки сообщений', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
        
        setChatLoadingState();
    }

    function setChatLoadingState (state = true) {
        let chatContainer = document.querySelector('.chat-container'),
            spinnerEl = document.querySelector('.chat-result-content .card-header i');

        if (!chatContainer || !spinnerEl) {
            return;
        }

        if (state) {
            chatContainer.classList.add('loading');
            spinnerEl.classList.remove('d-none');

            loadingMessages = true;
            return;
        }

        chatContainer.classList.remove('loading');
        spinnerEl.classList.add('d-none');

        loadingMessages = false;
    }

    bdy.on('keydown', '#chat-content .chat-message-input', function(e) {
        var chatInput = $(this);
        var chatContainer = $(this).closest('#chat-content').find('.chat-container');
        var chatId = chatInput.data('chatid');
        
        if (e.keyCode === 13) {
            if (e.shiftKey) {// Skip when end of line
                return;
            }
            else if (e.ctrlKey) {// Insert end of line
                chatInput[0].value = chatInput[0].value + '\n';
                chatInput[0].scrollTop = chatInput[0].scrollHeight;
                return;
            }

            e.preventDefault();
            if (window.messageIsSending)
                return false;

            window.messageIsSending = true;
            sendMessage(chatId, chatInput, function (data) {
                chatInput.val('');
                // Set default height
                chatInput[0].style.height = '5px';
                chatInput[0].style.height = (chatInput[0].scrollHeight)+'px';

                if (!!data.message) {
                    data.message.viewed = 1;
                    if (!chatContainer.find('.message[data-id="' + data.message.id + '"]').length) {
                        let message = data.message;
                        // Escape html characters <>
                        if (message.text) {
                            message.text = message.text.escape();
                        }
                        chatContainer.append($.render.messageItemTmpl(message));
                    }
                    showMeta(bdy.find('#chat-content .chat-container .message'));
                }
                chatContainer[0].scrollTop = chatContainer[0].scrollHeight;
            });
        } else if (e.keyCode >= 65 && e.keyCode <= 90) {
            sendTypingStatus(chatId);
        }
    });

    bdy.on('click', '#message-send-form .send-message', function(e) {
        e.preventDefault();
        if (window.messageIsSending)
            return false;

        window.messageIsSending = true;
        var chatInput = $(this).closest('form').find('.chat-message-input');
        var chatContainer = $(this).closest('#chat-content').find('.chat-container');
        var chatId = chatInput.data('chatid');
        sendMessage(chatId, chatInput, function (data) {
            chatInput.val('');
            if (!!data.message) {
                if (!data.multiple) {
                    data.message.viewed = 1;
                    if (!chatContainer.find('.message[data-mid="' + data.message.message_id + '"]').length) {
                        // Escape html <>& characters
                        let msg = data.message;
                        
                        if (msg.text) {
                            msg.text = msg.text.escape();
                        }

                        chatContainer.append($.render.messageItemTmpl(msg));
                    }
                } else {
                    for (var i in data.message) {
                        data.message[i].viewed = 1;
                        if (!chatContainer.find('.message[data-mid="' + data.message[i].message_id + '"]').length) {
                            // Escape html <> characters
                            let msg = data.message[i];
                            
                            if (msg.text) {
                                msg.text = msg.text.escape();
                            }

                            chatContainer.append($.render.messageItemTmpl(msg));
                        }
                    }
                }
                showMeta(bdy.find('#chat-content .chat-container .message'));
            }
            chatContainer[0].scrollTop = chatContainer[0].scrollHeight;
        });
    });

    bdy.on('submit', '#message-send-form', function(e) {
        e.preventDefault();
    });

    bdy.on('click', '.move-client', function(e){
        e.preventDefault();

        var $modal  = $('#group-edit-modal'),
            $select = $modal.find('select'),
            $form   = $modal.find('form'),
            $submit = $modal.find('.button-submit'),
            group   = $(this).data('group'),
            chatId  = $(this).closest('.chat-result-content').data('id');

        if (parseInt(group) > 0)
            $select.val(parseInt(group));

        $select.select2({
            theme: "bootstrap"
        }).on('select2:select', function (e) {
            $submit[0].disabled = true;
            $submit.attr('disabled', 'disabled');
            if (e.target.value.length > 0) {
                $submit[0].disabled = false;
                $submit.removeAttr('disabled');
            }

        });

        $form.off('submit').on('submit', function (evt) {
            evt.preventDefault();

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: {
                    group: $select.val(),
                    chatId: chatId
                },
                success: function (res) {
                    if (res.hasOwnProperty('success') && res.success === true) {
                        $modal.modal('hide');
                        $.growl('Новая группа успешно назначена', { type: 'info' });
                    } else {
                        if (typeof res.error !== 'undefined')
                            for (var x in res.error)
                                $.growl(res.error[x], {type: 'danger'});
                        else
                            $.growl('Ошибка переназначения группы пользователя', { type: 'danger' });
                    }
                },
                dataType: 'json'
            });
        });

        $modal.modal('show');
    });

    bdy.on('click', '.fix-client', function(e){
        e.preventDefault();

        let $button = $(this),
            chatId  = $button.closest('.chat-result-content').data('id');


        $.ajax({
            type: 'POST',
            url: "/chat/fixUser",
            data: {
                chatId: chatId
            },
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    if (!!res.successMessage)
                        $.growl(res.successMessage, { type: 'info' });
                    else
                        $.growl('Смена привязки прошла успешно', { type: 'info' });

                    if (res.type === 'off') {
                        $button.html($button.data('off'));
                        $button.addClass('btn-outline-danger').removeClass('user-fixed');
                        $button.parent().find('.move-client-user').addClass('d-none').data('assigned', false);
                    } else {
                        $button.html($button.data('on'));
                        $button.removeClass('btn-outline-danger').addClass('user-fixed');
                        $button.parent().find('.move-client-user').removeClass('d-none').data('assigned', window.userId);
                    }

                    if (messageInputsBlocked) {
                        toggleMessageInputs(true);
                    }
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка переназначения группы пользователя', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    });

    window.messageInputsBlocked = false;

    window.toggleMessageInputs = function (state = true) {
        let chatResultEl = document.querySelector('.chat-result-content');

        messageInputsBlocked = !state;

        if (state) {
            chatResultEl.querySelector('.chat-message-input').removeAttribute('disabled');
            chatResultEl.querySelector('button.send-attachments').removeAttribute('disabled');
            chatResultEl.querySelector('button.send-message').removeAttribute('disabled');
            return;
        }

        chatResultEl.querySelector('.chat-message-input').setAttribute('disabled', true);
        chatResultEl.querySelector('button.send-attachments').setAttribute('disabled', true);
        chatResultEl.querySelector('button.send-message').setAttribute('disabled', true);
    }

    bdy.on('click', '.move-client-user', function(e){
        e.preventDefault();

        var $button = $(this),
            chatId  = $button.closest('.chat-result-content').data('id'),
            assigned = $button.data('assigned'),
            $modal = bdy.find('#user-moveassign-modal'),
            $select = $modal.find('#userAssignSelectInput');

        $modal.find('.user-assign-id-input').val(chatId);
        $select.find('option').prop('disabled', false);
        $select.find('option[value="' + assigned + '"]').prop('disabled', true);
        $select.select2({
            theme: "bootstrap",
            placeholder: "Выберите кому назначить"
        });

        $modal.modal('show');
    });

    bdy.on('submit', '.users-moveassign-form', function (e) {
        e.preventDefault();
        var $form = $(this);
        var $modal = $('#user-moveassign-modal');

        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serializeArray(),
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    if (!!res.successMessage)
                        $.growl(res.successMessage, { type: 'info' });
                    else
                        $.growl('Пользователь успешно передан', { type: 'info' });
                    $modal.modal('hide');
                    $form[0].reset();
                    var openedGroup = bdy.find('#chat-content .chat-result-content').data('group');
                    bdy.find('#chatgroup-container .chatGroup-link[data-id="' + openedGroup + '"]').trigger('click');
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка передачи пользователя', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    });

    bdy.on('submit', '.users-view-form', function (e) {
        e.preventDefault();
        var $form = $(this);

        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serializeArray(),
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    if (!!res.successMessage)
                        $.growl(res.successMessage, { type: 'info' });
                    else
                        $.growl('Комментарий успешно обновлен', { type: 'info' });
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка обновления комментария', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    });

    bdy.on('submit', '.users-alias-form', function (e) {
        e.preventDefault();
        var $form = $(this);

        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serializeArray(),
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    if (!!res.successMessage) {
                        $.growl(res.successMessage, {type: 'info'});

                        if (res.chat) {
                            var $updatingChat = $('#chats-container').find('.chat-link[data-id="' + res.chat.chat_id + '"]');
                            var origChatName = $updatingChat.data('name');
                            var $updatingChatTitle = $('.chat-result-content').find('.card-header > span');

                            if (res.alias.length > 0) {
                                $updatingChat.find('.name-container').html(res.alias);
                                $updatingChatTitle.html(res.alias);
                            } else {
                                $updatingChat.find('.name-container').html(origChatName);
                                $updatingChatTitle.html(origChatName);
                            }
                        }
                    } else
                        $.growl('Псевдоним успешно обновлен', { type: 'info' });
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка обновления псевдонима', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    });

    bdy.on('click', '.chat-link .chat-info', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $link = $(this),
            chatId = $link.closest('.chat-link').data('chatid'),
            $modal = $('#user-view-modal');

        $.ajax({
            type: 'GET',
            url: "/chat/info/" + chatId,
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    $modal.find('.modal-body').html($.render.profileViewTmpl(res.chat));

                    $modal.modal('show');
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка получения данных чата', { type: 'danger' });
                }
            },
            dataType: 'json'
        });

    });

    bdy.on('click', '.load-more-messages', function (e) {
        e.preventDefault();

        var $btn = $(this),
            chatContainer = $(this).closest('#chat-content').find('.chat-container'),
            chatId  = $(this).closest('.chat-result-content').data('id'),
            $firstMessage = chatContainer.find('.message').eq(0),
            firstMessageId = $firstMessage.data('id');


        $.ajax({
            type: 'GET',
            url: '/chat/' + chatId + '/messages/' + firstMessageId,
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    console.log('message updated');
                    if (!!res.messages) {
                        // Escape html <> characters
                        res.messages.forEach(msg => {
                            msg.text = msg.text.escape();
                        });

                        $btn.after($.render.listMessagesTmpl(res));
                        showMeta(bdy.find('#chat-content .chat-container .message'));
                    }
                    chatContainer[0].scrollTo(0, ($firstMessage.offset().top - $firstMessage.height() - 20));
                    // Handle audio and voices
                    chatContainer.find('audio').each(function(idx, el) {
                        var duration = parseInt($(el).data('duration'));
                        if (isNaN(duration))
                            duration = -1;
                        $(el).mediaelementplayer({
                            features: ['playpause', 'progress', 'current'],
                            duration: duration,
                            success: function (media, node) {
                                $(node).addClass('style-converted');
                            }
                        });
                    });
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка загрузки сообщений', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    })

    bdy.on('click', '.ajax-link', function (e) {
        e.preventDefault();
        var $link = $(this);
        if ($link.attr('href').length && $link.attr('href') !== "#") {
            var $container = bdy.find('#ajax-response-modal');
            $container.find('.modal-body').html('');
            $container.find('.modal-title').html('');
            $.ajax({
                type: 'GET',
                url: $link.attr('href'),
                success: function (res) {
                    $container.find('.modal-body').html(res);
                    $container.find('.modal-title').html($link.attr('title'));
                    $container.modal('show');
                },
                dataType: 'html'
            });
        }

    });

    bdy.on('click', 'a.read-all-button', function (e) {
        e.preventDefault()

        let linkEl = this,
            groupLinkEl = document.querySelector('a.chatGroup-link.active'),
            groupId = document.querySelector('a.chatGroup-link.active').getAttribute('data-id')
        
        $.ajax({
            type: 'GET',
            url: linkEl.getAttribute('href') + groupId,
            success: function (res) {

                if (res >= 0)
                    $.growl('Сообщения прочитаны.', { type: 'info' })
                else
                    $.growl('Произошла ошибка чтения сообщений.', { type: 'danger' })

                if (res !== false) {
                    document.querySelector('#readAllInGroup').checked = true
                    document.querySelector('.read-all-button').classList.add('disabled')

                    let unreadEl = groupLinkEl.querySelector(`span.unread`)
                    unreadEl.innerHTML = '0'
                    unreadEl.classList.add('empty')
                    unreadEl.setAttribute('isRead', '')

                    let chatUnreadEls = document.querySelectorAll('#chats-container a.chat-link span.unread')

                    chatUnreadEls.forEach(el => {
                        el.innerHTML = '0'
                        el.classList.add('empty')
                        el.setAttribute('isRead', '')
                    })
                }

            },
            dataType: 'json'
        })
    })

    bdy.on('click', '[data-toggle="lightbox"]', function(e) {
        e.preventDefault();
        $(this).ekkoLightbox();
    });

    bdy.on('click', '.answer-link', function(e){
        e.preventDefault();

        var $link = $(this);
        var $container = $link.closest('.chat-result-content').find('.chat-container');
        var goTo = $link.data('rid');

        var $goToMessage = $container.find('.message[data-mid="' + goTo + '"]');

        $container.animate({
            scrollTop: "+=" + ($goToMessage.closest('.row').position().top - 150)
        }, 200, 'linear', function() {
            $container.find('.message.reply-highlight').removeClass('reply-highlight');
            $goToMessage.addClass('reply-highlight');
        });
    });

    bdy.on('click', '.reply-btn', function(e){
        e.preventDefault();

        var $link = $(this);
        var $message = $link.closest('.message');
        var $infoContainer = bdy.find('.reply-to-info-container');
        var $container = $link.closest('.chat-container');
        var messageId = $message.data('mid');

        var $goToMessage = $container.find('.message[data-mid="' + messageId + '"]');

        $container.animate({
            scrollTop: "+=" + ($goToMessage.closest('.row').position().top - 150)
        }, 200, 'linear', function() {
            $container.find('.message.reply-highlight').removeClass('reply-highlight');
            $goToMessage.addClass('reply-highlight');

            $infoContainer.html('Вы отвечаете на <a href="#" class="answer-link answer-link-form" data-rid="' + messageId + '">сообщение</a>&nbsp;<button type="button" class="close stop-answer"><span aria-hidden="true">×</span></button>');
        });

    });

    bdy.on('click', '.reply-to-info-container .stop-answer', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $container = $btn.closest('.chat-result-content').find('.chat-container');

        $(this).parent().html('');
        $container.find('.message.reply-highlight').removeClass('reply-highlight');
    });

    window.searchIsActive = false;

    let searchRequest = null,
        search = debounce(300, e => {
            e.preventDefault();
            
            let $container = $(document.querySelector('.user-search-block')),
                $input = $container.find('input'),
                $chatsListWrapper = bdy.find('#chats-container'),
                chatsListEl = document.querySelector('.original-chat-list-block');
            
            if (chatsListEl) {
                chatsListEl.hidden = true;
            }
            $chatsListWrapper.find('.search-results-list').remove();

            if (searchRequest) {
                searchRequest.abort();
                searchRequest = null;
            }
            
            if ($input.val().length > 2) {
                
                searchIsActive = true;

                let data = {
                    'data[query]': $input.val().toLowerCase()
                };
                
                searchRequest = $.ajax({
                    type: 'POST',
                    url: '/chat/search',
                    data: data,
                    success(res) {
                        if (res.hasOwnProperty('success') && res.success === true) {
                            
                            $chatsListWrapper.prepend(
                                $.render.searchBlockTmpl({
                                    searchItemsChats: res.chats,
                                    searchItemsMessages: res.messages,
                                    userId: window.userId,
                                    isDialogSearch: false
                                })
                            );
                        } else {
                            if (typeof res.error !== 'undefined')
                                for (var x in res.error)
                                    $.growl(res.error[x], {type: 'danger'});
                            else
                                $.growl('Ошибка обработки поиска', { type: 'danger' });
                        }
                    },
                    dataType: 'json'
                });

                $container.find('.close').css('visibility', 'visible');
                $container.find('.close').css('opacity', 1);
            } else {
                $container.find('.close').css('opacity', 0);
                setTimeout(() => {
                    $container.find('.close').css('visibility', 'hidden');
                }, 200);
                
                if (chatsListEl) {
                    chatsListEl.hidden = false;
                }
                searchIsActive = false;
            }
        });

    bdy.on('keyup', '.user-search-block input', search);

    let closeSearch = function (e) {
        $(this.nextElementSibling) // input
            .val('')
            .trigger('keyup');
    }

    bdy.on('click', '.user-search-block .close', closeSearch);


    window.setViewed = function(chatId, messageContainer) {
        $.ajax({
            type: 'GET',
            url: '/chat/set-viewed/'+chatId,
            success: function (res) {
                if (res.hasOwnProperty('success') && res.success === true) {
                    messageContainer.find('.message').removeClass('unread');
                } else {
                    if (typeof res.error !== 'undefined')
                        for (var x in res.error)
                            $.growl(res.error[x], {type: 'danger'});
                    else
                        $.growl('Ошибка отметки чатов прочитанными', { type: 'danger' });
                }
            },
            dataType: 'json'
        });
    };

    window.sendMessage = function(chatId, input, callback) {

        // Choose method of upload when files are added to input or not

        var fileInput = input.closest('form').find('.fileInput');

        if (fileInput.fileinput('getFileStack').length === 0) {
            let text = input.val(),
                sendData = {
                    text: text,
                    escapedText: text.escape()
                };
            
            if(bdy.find('.answer-link-form').length)
                sendData.replyto = bdy.find('.answer-link-form').data('rid');

            $.ajax({
                type: 'POST',
                url: '/chat/send/'+chatId,
                data: sendData,
                success: function (res) {
                    if (res.hasOwnProperty('success') && res.success === true) {
                        callback(res);
                    } else {
                        if (typeof res.error !== 'undefined')
                            for (var x in res.error)
                                $.growl(res.error[x], {type: 'danger'});
                        else
                            $.growl('Ошибка отправки сообщения', { type: 'danger' });
                    }
                    window.messageIsSending = false;
                },
                dataType: 'json'
            });
        } else {
            fileInput.off('fileuploaded filebatchuploadsuccess').on('fileuploaded filebatchuploadsuccess', function (event, data, previewId, index) {
                if (!!data.response) {
                    $(this).closest('form').find('textarea button').each(function(idx, el){
                        $(el).removeAttr('disabled');
                    });
                    window.messageIsSending = false;
                    $(this).fileinput('reset');

                    callback(data.response);
                }
            }).fileinput("upload");
        }
        bdy.find('.reply-to-info-container .stop-answer').trigger('click');
    };

    window.sendTypingStatus = throttle(3500, true, chatId => {
        if (parseInt(chatId) < 0)
            return true;

        $.ajax({
            type: 'GET',
            url: '/chat/typing/'+chatId,
            success: function (res) {
                if (typeof res.error !== 'undefined')
                    for (var x in res.error)
                        $.growl(res.error[x], {type: 'danger'});
            },
            dataType: 'json'
        });
    });


    window.playNotification = function() {
        if (!window.notificationPlaying) {
            var notification = new Audio('/assets/sound/notification.mp3');
            if (notification) {
                notification.play();
                window.notificationPlaying = setTimeout(function() { window.notificationPlaying = false;}, 10000);
            }
        }
    };

    window.showMeta = function($messages) {
        var previousUser = -1;
        var replyMessages = {};
        $messages.each(function (idx, el) {
            var $el = $(el), $row = $el.closest('.row');
            // Show avatar
            $row.removeClass('showAvatar');
            if ($el.data('sender') !== previousUser)
                $row.addClass('showAvatar');

            previousUser = $el.data('sender');

            // Assign replied message
            if ($el.find('.answer-link').length > 0) {
                var $answerLink = $el.find('.answer-link');
                var replyToId = $answerLink.data('rid');
                var $container = $answerLink.closest('.chat-container');

                if (!!replyMessages[replyToId]) {
                    var $goToMessage = replyMessages[replyToId];
                } else {
                    var $goToMessage = $container.find('.message[data-mid="' + replyToId + '"]').clone();
                    $goToMessage.find('.answer-link').remove();
                    replyMessages[replyToId] = $goToMessage;
                }

                if (!$answerLink.hasClass('reply-preview') && $goToMessage.length > 0) {
                    var sender = $goToMessage.closest('.row').find('.sender').text().trim();
                    if (!sender)
                        sender = $container.closest('.chat-result-content').find('.card-header > span').text().trim();

                    var mainText = $goToMessage.find('.card-body').text().trim();

                    var attachment = '';
                    if ($goToMessage.find('a').length)
                        attachment = '<span class="btn btn-light disable-user-select">' + $goToMessage.find('a').text().trim() + '</span>';

                    if ($goToMessage.find('img').length)
                        attachment = $goToMessage.find('img').prop('outerHTML');

                    if ($goToMessage.find('audio').length)
                        attachment = '<span class="btn btn-light disable-user-select">Голосовое сообщение</span>';

                    var replaceText = '<div class="reply-to-sender">' + sender + '</div><div class="reply-to-preview">' + (!!attachment ? attachment + '&nbsp;' : '') + '<span>' + mainText + '</span>' + '</div>';

                    $answerLink.html(replaceText).addClass('reply-preview');
                }
            }
        });
    };

    window.hashCode = function(str) { // java String#hashCode
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };

    window.intToRGB = function(i) {
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return "00000".substring(0, 6 - c.length) + c;
    };

    window.sortChatLink = (chat) => {
        let chats = document.querySelector('.chats-block').children,
            sortableEl = document.querySelector(`a.chat-link[data-id="${chat.chat_id}"]`),
            newLastMsgDate = parseInt(chat.last_message_date);

        if (!sortableEl) {
            return;
        }

        // If date is the same do not sort
        if (parseInt(sortableEl.getAttribute('data-last-message-date')) == newLastMsgDate) {
            return;
        }
        // Set new last message date
        sortableEl.setAttribute('data-last-message-date', newLastMsgDate);

        for (let chatEl of chats) {
            if (newLastMsgDate > parseInt(chatEl.getAttribute('data-last-message-date'))) {
                chatEl.parentNode.insertBefore(sortableEl, chatEl);
                break;
            }
        }
    };


    $.growl.default_options = {
        ele: "body",
        type: "info",
        allow_dismiss: false,
        position: {
            from: "top",
            align: "right",
            offset: 20,
            spacing: 10
        },
        z_index: 10031,
        fade_in: 400,
        delay: 5000,
        pause_on_mouseover: true,
        onGrowlShow: null,
        onGrowlShown: null,
        onGrowlClose: null,
        onGrowlClosed: null,
        template: {
            icon_type: 'class',
            container: '<div class="col-xs-10 col-sm-10 col-md-3 alert">',
            dismiss: '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>',
            title: '<strong>',
            title_divider: '',
            message: ''
        }
    };

    mejs.i18n.language('ru');

    $.views.settings.debugMode(true);
    $.views.settings.allowCode=true;

    $.views.helpers({
        formatString: function(str) {
            return str.linkify().replace(/\n/g, "<br/>")
        },
        getSender: function(senderId) {
            if (!!window.managers && !!window.managers[senderId])
                return window.managers[senderId].login;

            return "";
        },
        makeAvatar: function(id, local, chat) {
            id = Math.abs(id);

            if (local !== false)
                local = true;

            if (!!chat && !!chat.chat_id) {
                window.chats[id] = chat;
                window.chats[id].avatarId = chat.photo;
            }

            if (!local && !!window.chats && !!window.chats[id]) {
                if (!!window.chats[id].avatarId)
                    return '<div class="avatar-container a-picture outer" style="background-image: url(/getFileTG/' + window.chats[id].avatarId + ')"></div>';
                else {
                    var color = intToRGB(hashCode(window.chats[id].firstName));
                    return '<div class="avatar-container a-letter outer" style="background-color: #'+ color + '">' + window.chats[id].firstName.substring(0, 1).toUpperCase() + (window.chats[id].lastName ? window.chats[id].lastName.substring(0, 1).toUpperCase() : "") + '</div>';
                }
            }

            if (local && !!window.managers && !!window.managers[id]) {
                var color = intToRGB(hashCode(window.managers[id].login));
                return '<div class="avatar-container a-letter outer" style="background-color: #'+ color + '">' + window.managers[id].login.substring(0, 1).toUpperCase() + '</div>';
            }

            return ""
        }
    });

    bdy.on('hidden.bs.modal', '.modal', function () {
        $('.modal:visible').length && $(document.body).addClass('modal-open');
        var $selects = $(this).find('select');
        $selects.hasClass('select2-hidden-accessible') && $selects.select2('close');
    });
});
